import { Component, OnInit } from '@angular/core';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { CallBackEndService } from '../call-back-end.service';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

declare var getHexAscii: any;

@Component({
  selector: 'app-quick-transfer',
  templateUrl: './quick-transfer.component.html',
  styleUrls: ['./quick-transfer.component.css']
})
export class QuickTransferComponent implements OnInit {

  fromAccountNoQuick: any = '';
  toAccountNoQuick: any;
  ifsccdQuick: any;
  amountQuick: any;
  narrationQuick: any;
  isLoad: boolean;
  isShowQuick: string = 'page1';
  otpQuick: any;
  accountNo: any;
  message: string;
  disableNextBtn:boolean=false;
  disablesubBtn:boolean=false;

  regSpeci = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regchar = '/^[a-zA-Z]+$/';
  regexpspace = /\s+/;
  regZeroOnly = '^[0][0]*[0]$';
  regNum = /^.*[0-9]/;
  regexcap = /^.*?[A-Z]/;
  curRegExp = /^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/;
  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;

  fromAccountNoValidateQuick: string;
  disableAmtQuick: boolean;
  toAccountNoValidateQuick: string;
  fromandTOValidateQuick: string;
  toAcctmessageForSpace: string;
  toAcctmessageForacctspeci: string;
  toAcctmessageForacctLength: string;
  toAcctmessageForacctMinLength: string;
  toAcctCheckZeroOnly: string;
  ifsccdValidateQuick: string;
  ifscCodeNoSpaceQuick: string;
  ifscCodenotnospecialQuick: string;
  ifscCodenotlengthQuick: string;
  ifscCheckZeroOnlyQuick: string;
  amountNotlankQuick: string;
  disabletotpQuick: boolean;
  amountmessageForSpaceQuick: string;
  amountZeroOnlyQuick: string;
  notValidAmmountQuick: string;
  narrationValidateQuick: string;
  impsP2AOrP2P: any;
  ImpsP2AOrP2PValidate: string;
  fromAccountNoImps: any;
  ImpsfromAccountNoValidate: string;
  nickNameImps: any;
  nickNameImpsValidate: string;
  isShowImps: string;
  otpQuickValidate: string;
  disabledafterotp: boolean;
  error: string;
  showAcctBalance: string;
  showAllTransaction: string;
  accountInfo: any;
  transactionList: any;
  userName: string;
  scoAccounts: any;
  greterThanZero: string;
  OtpNotlank: string;

  constructor(private webService: CallBackEndService,
  private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.userName =sessionStorage.getItem('storedUserName');
    this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
  }

  ngOnInit() {
   
  }

  getOtpQuick() {
    
    this.error = '';
   // this.allValidation();
   // this.disableNextBtn=true;
    //if (this.fromAccountNoQuick  && this.ifsccdQuick && this.amountQuick && this.narrationQuick && !this.disableAmtQuick) {
    if(this.fromAcctValidateQuick() && this.toAcctValidateQuick() &&  this.ifscValidateQuick() &&  
    this.amounValidateQuick() && this.NarrationValidateQuick() ){
    this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.userName);
      request.param2 = this.userName;
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // console.log('Otp :' + response.param1);
          this.isShowQuick = 'page2';
         
        } else if (response !== null) {
          this.error = response.param1;
        } else {
        //  this.disableNextBtn=false;
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  quickFundTransferRequest() {
    this.error = '';
    this.disablesubBtn=true;
    if (this.fromAccountNoQuick && this.toAccountNoQuick && this.ifsccdQuick 
      && this.amountQuick && this.narrationQuick && this.otpQuick && this.getQuickOTPValid()){
    // && (this.fromAccountNoQuick !== this.toAccountNoQuick)  && !this.disableAmtQuick && !this.disabledafterotp) {
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      const otpDetails: any = { 
        'userName': this.userName,
        'otp': getHexAscii('',this.otpQuick),
        'imps': 'p2a',
        'creditIfscCd': this.ifsccdQuick
      };
      request.param1 = getHexAscii('', this.fromAccountNoQuick + this.toAccountNoQuick + this.amountQuick + this.narrationQuick + this.userName + this.otpQuick);// + 'p2a' + this.ifsccdQuick);
      console.log('24*7 p1:'+request.param1)
      request.param2 = this.fromAccountNoQuick;
      request.param3 = this.toAccountNoQuick;
      request.param4 = this.amountQuick;
      request.param5 = this.narrationQuick;
      request.param6 = otpDetails;
      this.isLoad = true;
      this.webService.getResponse(request, 'impsFundTransfer').subscribe((data: IbResponse) => {
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          this.accountNo = this.fromAccountNoQuick;
          //this.showTransaction();
          this.isShowQuick = 'page3';
          this.error = " Your transaction  completed successfully for Rs. "+ this.amountQuick + " to account No : "+this.toAccountNoQuick + " With Reference No :" + response.param2;
        } else if (response !== null) {
          // alert("Response is:"+response);
          this.error ='Your transaction is declined for Rs.'+this.amountQuick+' due to '+ response.param1;
          this.disabledafterotp=false;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
          this.disabledafterotp=false;
        }
      });
    }
  }
 

    allValidation() {
    this.fromAcctValidateQuick();
    if (!this.disableAmtQuick) {
      this.toAcctValidateQuick();
      if (!this.disableAmtQuick) {
        this.ifscValidateQuick();
      }if (!this.disableAmtQuick) {
          this.amounValidateQuick();
        }if (!this.disableAmtQuick) {
          this.NarrationValidateQuick();
        }
      }
    }

  showTransaction() {
    this.error = '';
    if (this.accountNo && this.accountNo !== '') {
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.accountNo);
      request.param2 = this.accountNo;
      this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
        response = data;
        this.isLoad = false;
        this.showAcctBalance = 'hide';
        this.showAllTransaction = 'hide';
        if (response !== null && response.status === 'S200') {
          this.accountInfo = response.param5;
          this.transactionList = response.param8;
          console.log('this.transactionList : ' + this.transactionList);
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  back() {
    this.error = '';
    this.otpQuick = '';
    this.isShowQuick = 'page1';
    this.disableNextBtn=false;
  }

  fromAcctValidateQuick() {
    if (this.fromAccountNoQuick === undefined || this.fromAccountNoQuick === '') {
      this.fromAccountNoValidateQuick = 'no';
       return false;
     // this.disabletotpQuick
    }else{
      this.fromAccountNoValidateQuick = '';
      return true;
    }
   
  }
  removeMessagefromQuick() {
    this.fromAccountNoValidateQuick = '';
   // this.disableAmtQuick = false;
  }
  toAcctValidateQuick() {
    if (this.toAccountNoQuick === undefined || this.toAccountNoQuick === '') {
      this.toAccountNoValidateQuick = 'no';
      return false;

    } else if (this.fromAccountNoQuick === this.toAccountNoQuick) {
      this.fromandTOValidateQuick = 'no';
      return false;

    } else if (this.toAccountNoQuick.match(this.regexpspace)) {
      this.toAcctmessageForSpace = 'no';
      return false;

    } else if (this.toAccountNoQuick.match(this.reg)) {
      this.toAcctmessageForacctspeci = 'no';
      return false;
    } else if (this.toAccountNoQuick.length >18)
    {
      this.toAcctmessageForacctLength = 'no';
      return false;
    } else if (this.toAccountNoQuick.length < 9) {
      this.toAcctmessageForacctMinLength = 'no';
      this.toAcctmessageForacctMinLength = 'no';
      this.toAcctmessageForacctMinLength = 'no';
      this.toAcctmessageForacctMinLength = 'no';
      this.toAcctmessageForacctMinLength = 'no';
      this.toAcctmessageForacctMinLength = 'no';
      this.toAcctmessageForacctMinLength = 'no';
      this.toAcctmessageForacctMinLength = 'no';
      this.toAcctmessageForacctMinLength = 'no';
      this.toAcctmessageForacctMinLength = 'no';
      return false;

    } else if (this.toAccountNoQuick.match(this.regZeroOnly)) {
      this.toAcctCheckZeroOnly = 'no';
      return false;

    }else{
      return true;

    }
 
  }
  removeMessagetoQuick() {
    this.toAccountNoValidateQuick = '';
    this.fromandTOValidateQuick = '';
    this.toAcctmessageForSpace = '';
    this.toAcctmessageForacctspeci = '';
    this.toAcctmessageForacctLength = '';
    this.toAcctmessageForacctMinLength = '';
    this.toAcctCheckZeroOnly = '';
   // this.disableAmtQuick = false;
  }
  ifscValidateQuick() {
    if (this.ifsccdQuick === undefined || this.ifsccdQuick === '') {
      this.ifsccdValidateQuick = 'no';
      return false;

    } else if (this.ifsccdQuick === ' ' || this.ifsccdQuick.indexOf(' ') !== -1) {
      this.ifscCodeNoSpaceQuick = 'no';
      return false;
    } else if (this.ifsccdQuick.match(this.reg)) {
      this.ifscCodenotnospecialQuick = 'no';
      return false;
    } else if (this.ifsccdQuick.length > 11||this.ifsccdQuick.length < 11) {
      this.ifscCodenotlengthQuick = 'no';
      return false;
    } else if (this.ifsccdQuick.match(this.regZeroOnly)) {
      this.ifscCheckZeroOnlyQuick = 'no';
      return false;
    }else{
      return true;
    }
  }
  removeMessageifscQuick() {
    this.ifsccdValidateQuick = '';
    this.ifscCodeNoSpaceQuick = '';
    this.ifscCodenotnospecialQuick = '';
    this.ifscCodenotlengthQuick = '';
    this.ifscCheckZeroOnlyQuick = '';
   // this.disableAmtQuick = false;
  }

  amounValidateQuick() {
    if (this.amountQuick === undefined || this.amountQuick === '') {
      this.amountNotlankQuick = 'no';
      return false;
      //this.disabletotpQuick = true;
    } else if (this.amountQuick.match(this.regexpspace)) {
      this.amountmessageForSpaceQuick = 'no';
      return false;
      //this.disabletotpQuick = true;
    } else if (this.amountQuick.match(this.regZeroOnly)) {
      this.amountZeroOnlyQuick = 'no';
      return false;
      //this.disabletotpQuick = true;
    } else if (!this.amountQuick.match(this.curRegExp)) {
      this.notValidAmmountQuick = 'no';
      return false;
      //this.disabletotpQuick = true;
    } else if ( parseFloat(this.amountQuick) <= 0) {
      this.greterThanZero = 'no';
      return false;
     // this.disabletotpQuick = true;
    }else{
      return true;
     
    }
  }
  removeMessagetoAmountQuick() {
    this.amountNotlankQuick = '';
    this.amountmessageForSpaceQuick = '';
    this.amountZeroOnlyQuick = '';
    this.notValidAmmountQuick = '';
    this.greterThanZero = '';
   // this.disabletotpQuick = false;
  // this.disableAmtQuick=false;
  }
  NarrationValidateQuick() {
    if (this.narrationQuick === undefined || this.narrationQuick === '') {
      this.narrationValidateQuick = 'no';
      return false;
     // this.disabletotpQuick = true;
    }else{
      this.narrationValidateQuick = '';
      return true;
    }
  }
  removeMessageNarratinQuick() {
    this.narrationValidateQuick = '';
    //this.disableAmtQuick=false;
   // this.disabletotpQuick = false;
  }
  nextImps() {
    if (this.impsP2AOrP2P === undefined || this.impsP2AOrP2P === '') {
      this.ImpsP2AOrP2PValidate = 'no';
      this.disabletotpQuick = true;

    } else if (this.fromAccountNoImps === undefined || this.fromAccountNoImps === '') {
      this.ImpsfromAccountNoValidate = 'no';
      this.disabletotpQuick = true;

    } else if (this.nickNameImps === undefined || this.nickNameImps === '') {
      this.nickNameImpsValidate = 'no';
      this.disabletotpQuick = true;

    } else if ((this.impsP2AOrP2P && this.fromAccountNoImps)) {
      this.isShowImps = 'hide1';
    }
  }

  getQuickOTPValidOld() {
    if (this.otpQuick === undefined || this.otpQuick === '') {
      this.otpQuickValidate = 'no';
      this.disabledafterotp = true;
    }else{
      this.otpQuickValidate = '';
      this.disabledafterotp = false;
    }
  }
  getQuickOTPValid() {
    if (this.otpQuick === undefined || this.otpQuick === '') {
      this.OtpNotlank = 'no';
     return false;
    }else if (this.otpQuick.match(this.reg)) {
      this.OtpNotlank = 'specialChar';
      return false;
    }else if (!this.otpQuick.match(this.regNum)) {
      this.OtpNotlank = 'num';
      return false;
    } else if (this.otpQuick.length!=6) {
      this.OtpNotlank = 'len';
      return false;
    }else{
      this.OtpNotlank = '';
      return true;
    }
  }
  getQuickmesageOTPRemove() {
    this.otpQuickValidate = '';
    this.OtpNotlank = '';
    this.error='';
    //this.disabledafterotp = false;
  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/quick-transfer/quick-transfer.component.ts